module.exports = __webpack_public_path__ + "static/media/telephone_site.63e84c42.png";